// extracted by mini-css-extract-plugin
export default {"button":"GraphHeaderButton_button__KLWHp","input":"GraphHeaderButton_input__arFBV"};